/* eslint-disable no-unused-vars */
import React, { useEffect, useContext } from "react";
import { useState } from "react";
import { FaSearch, FaRegUserCircle } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { toast } from "react-toastify";
import { useHistory, useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { signout } from "../../common/apiService";
import { clearStorage } from "../../service/utilService";
import { UserContext } from "../../contexts/UserContext";
import "./header.css";

export default function Header() {
  const userDetail = useContext(UserContext);
  const [searchtext, setSearchText] = useState("");
  const [showpopup, setShowPopup] = useState(false);
  const [user, setUser] = useState("");
  const [pathName, setpathName] = useState("");
  const [searchType, setSearchType] = useState("RRN");

  const searchOptions = [
    { value: "RRN", label: "RRN" },
    { value: "TxnId", label: "Agency Txn ID" },
    { value: "TagId", label: "Tag ID" },
    { value: "RegNo", label: "Reg. No" },
  ];

  let history = useHistory();
  let location = useLocation();
  useEffect(() => {
    setpathName(location.pathname?.toLowerCase());
  }, [location]);

  useEffect(() => {
    setUser(userDetail);
  }, [userDetail]);

  const checkEnterKey = (evt) => {
    if (evt.key === "Enter") {
      redirectToListingPage();
    }
  };

  const redirectToListingPage = () => {
    if (searchtext) {
      if (searchtext.length > 1) {
        history.push("/dashboard/violations", {
          searchtext: searchtext,
          searchType: searchType,
        });
      } else toast.warning("Please Enter Valid value");
    } else toast.warning("Please Enter a Value first!");
    document.getElementById("search").value = "";
  };
  const showHideSidebar = () => {
    document.getElementById("logo1").classList.toggle("d-none");
    document.getElementById("sidebar").classList.toggle("hidesidebar");
    document.getElementById("content").classList.toggle("fullcontent");
    document.getElementsByClassName("arrow")[0].classList.toggle("left");
    Array.from(document.getElementsByClassName("shortsidebaricon")).forEach(
      (e) => {
        e.classList.toggle("showicon");
      }
    );
    Array.from(document.getElementsByClassName("sidebar-label")).forEach(
      (e) => {
        e.classList.toggle("hide-label");
      }
    );
  };

  const logout = () => {
    signout();
    clearStorage();
    history.push("/");
  };
  return (
    <>
      <div className="row" id="searchbar">
        <div className="col-md-6">
          <span>
            <div className="bar-container" onClick={showHideSidebar}>
              <i className="arrow left"></i>
            </div>
          </span>
          {!pathName.includes("concessionairedashboard") &&
            !pathName.includes("raisednewviolation") && (
              <span id="searchbox-span">
                <select
                  value={searchType}
                  onChange={(e) => setSearchType(e.target.value)}
                  className="search-type-select"
                >
                  <option value="">Type</option>
                  <option value="RRN">RRN</option>
                  <option value="TxnId">Agency Txn ID</option>
                  <option value="TagId">Tag ID</option>
                  <option value="RegNo">Reg. No</option>
                </select>

                <input
                  type="search"
                  placeholder={
                    searchType ? `Search by ${searchType}` : "Select type first"
                  }
                  id="search"
                  maxLength="30"
                  autoComplete="off"
                  onKeyDown={searchType ? checkEnterKey : undefined}
                  onChange={(evt) => setSearchText(evt.target.value)}
                  disabled={!searchType}
                  className="search-input"
                />

                <FaSearch
                  onClick={() => {
                    if (searchType && searchtext) redirectToListingPage();
                  }}
                  // className="search-icon"
                  style={{
                    cursor:
                      searchType && searchtext ? "pointer" : "not-allowed",
                    opacity: searchType && searchtext ? 1 : 0.4,
                  }}
                />
              </span>
            )}
        </div>

        <div className="col-md-6">
          <div className="user" onClick={() => setShowPopup(true)}>
            {user.username}
            <FiChevronDown />
            <br />
            <span style={{ width: "auto", fontSize: 11 }}>
              {" "}
              UT : Toll / LA : {moment(new Date()).format(
                "DD MMMM,yyyy hh:mm"
              )}{" "}
            </span>
          </div>
          <div className="notification">
            {/* <a href="">
<FaBell />
</a> */}
          </div>
        </div>
      </div>
      <Modal
        show={showpopup}
        onHide={() => setShowPopup(false)}
        className="header-popup"
      >
        <Modal.Body clasame="">
          <div className="logout-block1">
            <ul>
              <li>Logout</li>
            </ul>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
